import styled from 'styled-components';

const MODAL_FOOTER_HEIGHT = 120;
const MODAL_WIDTH_CENTER = 785;
const MODAL_WIDTH_SIDE = 500;

const StyledFormModalProvider = styled.div`
  :global(form-modal-provider) {
    :global(.modal.fade:not(.in).right .modal-dialog) {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    :global(.modal .modal-dialog) {
      height: 90vh;
      min-width: ${MODAL_WIDTH_CENTER}px;
    }

    :global(.modal.left .modal-dialog),
    :global(.modal.right .modal-dialog) {
      height: 100vh;
      min-width: ${MODAL_WIDTH_SIDE}px;
      overflow-y: hidden;
      overflow-x: hidden;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: 0;
    }

    :global(.modal.left .modal-dialog) {
      left: 0;
    }

    :global(.modal.right .modal-dialog) {
      right: 0;
    }

    :global(.modal.left .modal-dialog .modal-content),
    :global(.modal.right .modal-dialog .modal-content) {
      height: 100vh;
      border: 0;
      border-radius: unset;
      background-color: ${({ theme }) => theme.colors.background};
    }

    :global(.modal-dialog.modal-sm) {
      min-width: unset;
    }

    // Bokita modal styles

    :global(.modal-navigation) {
      position: relative;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      border-bottom: 1px solid #d8d8d8;
      flex-basis: 200px;
      display: flex;
      flex-direction: column;
      background-color: #f2f2ed;
      color: black;
      padding: 35px 0;

      & button {
        user-select: none;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 16px;
        margin: 0 0 24px 0;
        background-color: transparent;
        color: black;
        border: unset;
        border-left: 3px solid transparent;
        -webkit-transition: border-color 0.3s ease-out;
        -moz-transition: border-color 0.3s ease-out;
        -o-transition: border-color 0.3s ease-out;
        transition: border-color 0.3s ease-out;

        svg {
          margin-right: 16px;
        }
      }

      & .button-active,
      & button:hover {
        color: $color-d1;
        border-left: 3px solid ${({ theme }) => theme.colors.primary2};
        -webkit-transition: border-color 0.3s ease-out;
        -moz-transition: border-color 0.3s ease-out;
        -o-transition: border-color 0.3s ease-out;
        transition: border-color 0.3s ease-out;
      }
    }

    :global(.modal-close-button) {
      position: absolute;
      top: 0;
      right: 0;
      margin: 14px;
    }

    :global(.modal-body-wrapper) {
      display: flex;
      flex-direction: column;
      height: calc(90vh - 50px);
      flex-basis: 800px;
      background-color: ${({ theme }) => theme.colors.background2};
    }

    :global(.modal-body) {
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      margin-top: 54px;
      padding: 36px 30px 0 30px;
      width: 100%;

      &:after {
        content: '';
        display: block;
        height: 70px;
        width: 100%;
      }

      input,
      select {
        width: 100%;
      }
    }

    .modal-footer {
      border-top: 1px solid #d8d8d8;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      -webkit-justify-content: flex-end;
      align-items: center;
      padding-right: 36px;
      width: 100%;
      height: ${MODAL_FOOTER_HEIGHT}px;
    }

    :global(.modal-footer-button) {
      top: 50%;
    }

    :global(.form-steps-edit-mode) {
      margin: -16px;
      padding: 16px;
    }

    :global(.form-steps-edit-mode.enabled) {
      background-color: #ecece5;
      border-radius: 4px;
    }

    :global(.form-steps-divider) {
      border-bottom: 1px solid #191919;
      box-sizing: border-box;
      opacity: 0.1;
    }

    :global(.modal.modal-static .modal-dialog) {
      transform: unset;
    }

    :global(.modal-wrapper) {
      display: flex;
    }

    :global(.tabs-separator) {
      margin: 0 20px 24px 20px;
      border-bottom: ${({ theme }) => theme.colors.d3gray};
    }
  }
`;

export default StyledFormModalProvider;
